(function () {
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const chromeClass = "landu-hub-page--chrome-hidden";

  function syncThemeChrome() {
    const shouldHide = document.querySelector('[data-hide-theme-chrome="true"]') !== null;
    document.documentElement.classList.toggle(chromeClass, shouldHide);
  }

  function setupCarousel(carousel) {
    if (carousel.dataset.carouselReady === "true") return;

    const cards = Array.from(carousel.querySelectorAll(".landu-hub__category"));
    const explore = carousel.closest(".landu-hub__explore");
    const previous = explore && explore.querySelector("[data-category-prev]");
    const next = explore && explore.querySelector("[data-category-next]");
    const status = explore && explore.querySelector("[data-category-status]");

    if (!cards.length || !previous || !next || !status) return;

    carousel.dataset.carouselReady = "true";
    let activeIndex = 0;
    let frame;

    const cardLeft = (card) => card.getBoundingClientRect().left - carousel.getBoundingClientRect().left + carousel.scrollLeft;

    const update = () => {
      activeIndex = cards.reduce((closest, card, index) => (
        Math.abs(cardLeft(card) - carousel.scrollLeft) < Math.abs(cardLeft(cards[closest]) - carousel.scrollLeft) ? index : closest
      ), 0);
      status.textContent = `${activeIndex + 1} / ${cards.length}`;
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === cards.length - 1;
    };

    const goTo = (index) => {
      const target = Math.max(0, Math.min(index, cards.length - 1));
      carousel.scrollTo({ left: cardLeft(cards[target]), behavior: reducedMotion.matches ? "auto" : "smooth" });
    };

    previous.addEventListener("click", () => goTo(activeIndex - 1));
    next.addEventListener("click", () => goTo(activeIndex + 1));
    carousel.addEventListener("scroll", () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  }

  function setup(root) {
    root.querySelectorAll("[data-category-carousel]").forEach(setupCarousel);
  }

  document.addEventListener("DOMContentLoaded", () => {
    syncThemeChrome();
    setup(document);
  });
  document.addEventListener("shopify:section:load", (event) => {
    syncThemeChrome();
    setup(event.target);
  });
  document.addEventListener("shopify:section:unload", () => window.requestAnimationFrame(syncThemeChrome));
})();
